export const environment = {
  production: true,
  apiUrl: "https://goldsoftware-preview.itkaufmann.cloud/api",
  apiFileUrl: "https://goldsoftware-preview.itkaufmann.cloud/",
  passwordMinLength: 8,
  displayDateFormat: "dd.MM.yyyy",
  serverDateFormat: "yyyy-MM-dd",
  // Sprint 5c S5c-13 (Tag 6): Default HTTP gegen die Preview-Umgebung.
  authMode: 'http' as 'dummy' | 'http',
  dataSource: 'http' as 'dummy' | 'http',
  // Fake-Latenz für alle Dummy-Facades (Sprint 2, S2-6). Hochdrehen,
  // um Skeletons in der Demo deutlich sichtbar zu machen (z. B. 1200).
  dummyLatencyMs: 250,
  // Liste der Dummy-Facade-Keys, die Error-Responses liefern sollen
  // (Sprint 3 Tag 0, Retro-Action #6). Leer = alle Facades liefern normal.
  // Werte: siehe `DummyFacadeKey` in `app/data/dummy-response.util.ts`.
  dummyErrorFacades: [] as readonly string[],
};
